import React, { useState } from 'react'
import CustomCard from '../../Shared/Components/CustomCard/CustomCard'
import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import ActionButtons from '../../Shared/Components/ActionButtons'
import InfoIcon from '@mui/icons-material/Info';
import { useNavigate } from 'react-router-dom'
import { useCreateRedirect } from '../../Shared/Hooks/useCreateRedirect';
import { useDeleteSelectedItems } from '../../Shared/Hooks/useDeleteSelectedItems';
import DataTable, { ColumnConfig } from '../../Shared/Components/DataTable'
import { useDeleteRegionMutation, useGetRegionsQuery } from '../Service/regionsApi'
import { Region } from '../Types/regionTypes'
import { RegionsRoutes } from '../../../Router/path'

const Regions = () => {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedRegionIds, setSelectedRegionIds] = useState<number[]>([]);

    const { data, isLoading, isError, error } = useGetRegionsQuery()


    const [deleteRegion] = useDeleteRegionMutation();
    const navigate = useNavigate();
    const handleCreate = useCreateRedirect(RegionsRoutes.create);
    const handleDeleteSelected = useDeleteSelectedItems<number>(
        selectedRegionIds,
        (id) => deleteRegion(id).unwrap(),
        () => setSelectedRegionIds([])
    );

    const columns: ColumnConfig<Region>[] = [
        { key: "id", label: "ID" },
        { key: "name", label: "Nazwa" },
        { key: "countryName", label: "Kraj" },
    ];

    return (
        <>
            <CustomCard
                icon={<InfoIcon fontSize="large" color="primary" />}
                title="Regiony"
                subheader="Zarządzaj regionami w systemie"
                sx={{ mb: 4 }}
            >
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body1" gutterBottom>
                        Na tej stronie zarządzasz wszystkimi dostępnymi regionami w systemie.
                        Możesz przeglądać listę istniejących regionów wraz z podstawowymi informacjami (nazwa, lokalizacja, status).
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Skorzystaj z przycisków, aby dodać nowy region lub usunąć
                        wybrane pozycje.
                    </Typography>
                </Box>

                <ActionButtons
                    onCreate={handleCreate}
                    onDeleteSelected={handleDeleteSelected}
                />
            </CustomCard>
            <CustomCard >
                <DataTable
                    columns={columns}
                    data={(data || []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
                    isLoading={isLoading}
                    isError={isError}
                    errorMessage={(error as any)?.data?.message}
                    getRowId={(row) => row.id}
                    onEdit={(id) => {
                        const item = data?.find(item => item.id === id);
                        if (item) {
                            navigate(RegionsRoutes.update.replace(":regionId", item.id.toString()));
                        }
                    }}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalCount={data?.length ?? 0}
                    onPageChange={(newPage) => setPage(newPage)}
                    onRowsPerPageChange={(newSize) => {
                        setRowsPerPage(newSize);
                        setPage(0);
                    }}
                    selected={selectedRegionIds}
                    onSelectionChange={(selectedIds) => {
                        setSelectedRegionIds(selectedIds);
                    }}
                />
            </CustomCard>

        </>
    )
}

export default Regions